/* eslint-disable new-cap */
import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Paper,
  TextField,
} from '@material-ui/core'
import { Delete, Remove, Add } from '@mui/icons-material'
import style from './index.module.css'
import Image from '../../Image/Image'
import { handleBuy } from '../../../../utils/User/helper/functions'

const Cart = (props) => {
  const {
    pesti: {
      id, name, image, price, discount, quantity, season, rating, detail, composition, categoryId, type,
    },
    handleRemove,
    handleItemCount,
    itemCount,
    history,
  } = props

  const { pesti } = props

  return (
    <>
      <div className='row mx-0'>
        <div className={ `card mt-1 ${ style.background }` }>
          <div>
            <Image
              src={ `${ process.env.REACT_APP_IMAGE_URL }${ image }` }
              alt='product'
              className={ style.image }
            />
            <div className={ style.itemCountContainer }>
              <span><Remove /></span>
              <input type='number' className={ style.itemCount } placeholder='Items' />
              <span><Add /></span>
            </div>
          </div>
          <div>
            <div className='product-1 align-items-center p-2 text-center'>
              <h5>{ name }</h5>
              <div className='info'>
                <span className='text1'>{ composition }</span>
                <span className='text1'>{ quantity }</span>
              </div>
              <div className=' cost text-dark'>
                <span>{ price }</span>
              </div>
            </div>
            <div className={ style.addToCart }>
              <Button
                type='button'
                className='p-2 m-2'
                onClick={ () => handleBuy(pesti, history) }
              >
                Buy
              </Button>
              <Button
                type='button'
                onClick={ handleRemove }
                className='p-2 m-2'
              >
                <Delete />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Cart

Cart.propTypes = {
  pesti: PropTypes.objectOf.isRequired,
  handleRemove: PropTypes.func.isRequired,
  history: PropTypes.objectOf.isRequired,
  handleItemCount: PropTypes.func.isRequired,
  itemCount: PropTypes.number.isRequired,
}
